module.exports = __webpack_public_path__ + "img/ANTENNA WAVES PURPLE.8764cc0.svg";